import {Subject} from 'rxjs';
import {TStackPanelId} from './interface';

export class StackPanelRef<T = unknown> {
  id?: TStackPanelId;
  content?: T;
  readonly onHide: Subject<TStackPanelId | undefined> = new Subject();
  readonly onHidden: Subject<TStackPanelId | undefined> = new Subject();
  private beforeHideGuard?: () => boolean;

  constructor(
    private readonly hideById: (id?: TStackPanelId) => void,
    id?: TStackPanelId,
  ) {
    this.id = id;
  }

  hide(): void {
    this.hideById(this.id);
  }

  canHide(): boolean {
    if (!this.beforeHideGuard) {
      return true;
    }

    return this.beforeHideGuard();
  }

  setBeforeHideGuard(guard?: () => boolean): void {
    this.beforeHideGuard = guard;
  }
}
